

export enum KalturaESearchHistoryAggregateFieldName {
    searchTerm = 'search_term'
}